const API_URL = import.meta.env.VITE_API_URL;
const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;
const SPLIT_KEY = import.meta.env.VITE_SPLIT_KEY;
const PRODUCTION_MODE = "prod";
const IS_PROD = import.meta.env.MODE === PRODUCTION_MODE;
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
const DISABLED_LOGGER = import.meta.env.VITE_ENABLE_LOGGER === "false";
const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
const BRAZE_API_KEY = import.meta.env.VITE_BRAZE_API_KEY;
const BRAZE_SDK_ENDPOINT = import.meta.env.VITE_BRAZE_SDK_ENDPOINT;

export {
  AMPLITUDE_API_KEY,
  API_URL,
  DISABLED_LOGGER,
  ENVIRONMENT,
  IS_PROD,
  SPLIT_KEY,
  AUTH0_DOMAIN,
  AUTH0_CLIENT_ID,
  BRAZE_API_KEY,
  BRAZE_SDK_ENDPOINT,
};
